<template>
  <div class="app-body">

    <el-form
        :inline="true"
        :model="queryForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item label="统计年份：" prop="year">
        <el-date-picker
            v-model="queryForm.year"
            type="year"
            placeholder="选择年"
            size="mini"
            style="width: 140px"
            value-format="yyyy"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="外销合同号：" prop="orderCode">
        <el-input
            type="text"
            size="mini"
            v-model="queryForm.orderCode"
            placeholder="请输入外销合同号"
            style="width:160px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="客户：" prop="customerId">
        <customer v-model="queryForm.customerId" clearable></customer>
      </el-form-item>
      <el-form-item label="出口发票号：" prop="receiptCode">
        <el-input
            type="text"
            size="mini"
            v-model="queryForm.receiptCode"
            placeholder="请输入出口发票号"
            style="width:160px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="品番：" prop="productName">
        <el-input
            v-model="queryForm.productName"
            size="mini"
            clearable
            type="text"
            style="width:200px;"
            placeholder="请输入品番号/品名/颜色/规格/幅宽/克重"
        ></el-input>
      </el-form-item>
      <el-form-item label="加工单位：" prop="productName">
        <company v-model="queryForm.sellerId"></company>
      </el-form-item>
      <el-form-item prop="isEnd">
        <el-checkbox v-model="queryForm.isEnd" true-label="1" false-label="" @change="reload">已结束订单</el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getDataList" size="mini"
        >查询
        </el-button
        >
        <el-button @click="reset" size="mini">重置</el-button>
        <el-button type="warning" size="mini" @click="exportAllData()"
        >导出
        </el-button
        >
        <el-button type="danger" size="mini" @click="caculeAll()">订单成本核算</el-button>
      </el-form-item>
    </el-form>
    <SweetTable ref="table" :query-form="queryForm" url="/trade/boxform/report"
                :summaries-column="['saleAmount', 'costAmount', 'count']">
      <el-table-column
          prop="receiptCode"
          label="发票号" align="center" header-align="center"
      ></el-table-column>
      <el-table-column
          prop="makeCompanyName"
          label="加工单位" align="center" header-align="center"
          :formatter="$c.companyNameFormatter"
      ></el-table-column>
      <el-table-column
          prop="agreementCode"
          label="合同号"
          align="left" header-align="center"
      >
        <template #default="{row}">
          <i class="el-icon-refresh" style="margin-right:4px;color:#409EFF;cursor: pointer"
             @click="caculeAll(row.orderId)"></i>
          <span>{{ row.agreementCode }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="productCode"
          label="品番号"
          align="center" header-align="center"
      ></el-table-column>
      <el-table-column prop="productName" label="品名" align="center" header-align="center"></el-table-column>
      <el-table-column prop="color" label="颜色" align="center" header-align="center"></el-table-column>
      <el-table-column prop="size" label="规格" align="center" header-align="center"></el-table-column>
      <el-table-column prop="count" label="出口数量" width="90" align="center" header-align="center"></el-table-column>
      <el-table-column
          prop="salePrice"
          label="外销单价"
          min-width="90" align="left" header-align="center"
      ></el-table-column>
      <el-table-column prop="saleAmount" label="外销额" width="90" align="center" header-align="center">
      </el-table-column>
      <el-table-column prop="costPrice" label="成本价格" width="90" align="center" header-align="center">
      </el-table-column>
      <el-table-column prop="costAmount" label="成本金额" width="90" align="center" header-align="center">
        <template #default="{row}">
          <span v-if="row.orderStatus!==200" style="color: red;" v-text="row.costAmount"></span>
          <span v-else v-text="row.costAmount"></span>
        </template>
      </el-table-column>
      <el-table-column prop="payCode" label="付款发票号" min-width="90" align="center"
                       header-align="center"></el-table-column>
      <el-table-column prop="rate" label="换汇" width="90" align="center" header-align="center"></el-table-column>
      <el-table-column prop="shipDate" label="日期" width="100" align="center" header-align="center"></el-table-column>
      <el-table-column
          prop="customerName"
          label="客户名称"
          min-width="180" align="center" header-align="center"
      ></el-table-column>
      <el-table-column
          prop="businessMan"
          label="业务员"
          width="100" align="center" header-align="center"
      ></el-table-column>
      <el-table-column
          prop="creatorName"
          label="制单人"
          width="100" align="center" header-align="center"
      ></el-table-column>
    </SweetTable>
  </div>
</template>

<script>
import moment from 'moment'
import SweetTable from '@/mixins/SweetTable'

export default {
  name: 'make-report',
  mixins: [SweetTable],
  data () {
    return {
      queryForm: {
        year: '',
        orderCode: '',
        productName: '',
        receiptCode: '',
        customerId: '',
        boxType: 'outlet',
        sellerId: '',
        isEnd: ''
      },
    }
  },
  methods: {

  }
}
</script>
